import 'core-js';
import 'core-js/features/reflect';

/* eslint-disable */
if ((<any>window).NodeList && !NodeList.prototype.forEach) {
    (<any>NodeList).prototype.forEach = Array.prototype.forEach;
}

(window as any).__Zone_enable_cross_context_check = true;
(window as any).global = window;
/* eslint-enable */

import 'zone.js';
import 'zone.js/plugins/zone-error';
